import { Icon } from "@atoms";
import { faIcon } from "@utils/faIcon";
import React, { Component } from 'react';
import { valueIsDefined } from "../utils/utils";


class PriceField extends Component {

    render() {
        const {fieldName, fieldLabel, fieldValue, fieldOnChange, currencySymbol, credit=false, disabled=false, optional=false, optionalText="optional", isLoading=false, extraClasses=null, errors} = this.props
        // A value that is still loading would be overwritten when it lands, so it can't be edited meanwhile.
        const isDisabled = disabled || isLoading

        return (
            <div className={`data-panel__form__field ${extraClasses !== null ? extraClasses.join(" ") : ""}`} id={`div_id_${fieldName}`} aria-label={fieldLabel}>
                <label htmlFor={`id_${fieldName}`} className="data-panel__form__field__label in-form">{fieldLabel}{optional && <span className="text-optional"> ({optionalText})</span>}</label>
                <div className="data-panel__form__field__input">
                    <div className="data-panel__form__field__input-group" title={isDisabled && fieldValue ? `${currencySymbol}${fieldValue}` : null}>
                        <div className="input-group-prepend">
                            <div className="input-group-text">{currencySymbol}</div>
                        </div>
                        <input
                            defaultValue={valueIsDefined(fieldValue) ? parseFloat(fieldValue) * (credit ? -1 : 1) : ""}
                            onChange={event => fieldOnChange(valueIsDefined(event.target.value) ? event.target.value * (credit ? -1 : 1) : null)}
                            type="number"
                            min="0"
                            max="9999999"
                            step="0.5"
                            id={`id_${fieldName}`}
                            name={fieldName}
                            autoComplete="off"
                            className={isDisabled ? "is-disabled" : ""}
                            disabled={isDisabled}
                        />
                        {isLoading && (
                            <div className="input-group-append">
                                <div className="input-group-text" aria-label="Loading price...">
                                    <Icon containerClassName="icon-inline" icon={faIcon({ name: "spinner-third", style: "regular" })} spin />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {errors[fieldName] && <div className="data-panel__form__field__errors" aria-label="Field Errors">{errors[fieldName]}</div>}
            </div>
        )
    }
}

export default PriceField;
